import * as Redux from 'redux';
import { resultsModel } from './results-model';
import { sortsModel } from './sorts-model';
import { pageModel } from './page-model';
import { searchTermModel } from './search-term-model';
import { epiPropsModel } from './epi-props-model';
import { facetsModel } from './facets-model';
import { ISearchResult, IResults } from '../state-helpers/search-results';
import { IFacets } from '../state-helpers/facets';
import { ISort } from '../state-helpers/sorts';
import { ISearchCriteria } from '../state-helpers/search-criteria';
import { IPage } from '../state-helpers/page';
import { IEpiProps } from '../state-helpers/epi-props';
import { IAutocompleteResults } from '../state-helpers/autocomplete-results';
import { autocompleteResultsModel } from './autocomplete-results-model';
import { browserNavigated } from './browser-navigated';
import { ui } from './ui';

import { selectedSearchContext } from './selected-search-context'
import { ISearchContext } from '../../global/models/search-context';

// The goal is to get rid of this, try to refain from adding to it
export interface ISearchAppState {
    resultsModel: IResults;
    sortsModel: ISort[];
	facetsModel: IFacets;
    pageModel: IPage;
    autocompleteResultsModel: IAutocompleteResults;
    searchTermModel: string;
    browserNavigated: boolean;
    epiPropsModel: IEpiProps;

    selectedSearchContext: ISearchContext
}    


export const rootReducer = Redux.combineReducers({
    resultsModel,
    sortsModel,
    searchTermModel,
    epiPropsModel,
    pageModel,
    autocompleteResultsModel,
    browserNavigated,
    ui,
    facetsModel,

    selectedSearchContext
});